module.exports = __webpack_public_path__ + "img/SHIKAKU_APP.7efe4bb5.svg";